// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import 'expose-loader?jQuery!jquery' // eslint-disable-line
import 'expose-loader?$!jquery' // eslint-disable-line
import { abilitiesPlugin } from '@casl/vue';
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
import '@/css/copilotkit/styles.css';
import VueTouch from 'vue-touch';
/* eslint-disable-next-line*/
import { ClientTable } from 'vue-tables-2';
import VueTextareaAutosize from 'vue-textarea-autosize';
import { VueMaskDirective } from 'v-mask';
import VeeValidate from 'vee-validate';
import VueFormWizard from 'vue-form-wizard';
import store from './store';
import router from './Routes';
import App from './App';
import Editor from 'vue-editor-js'
import { Ability } from '@casl/ability';
import vClickOutside from 'v-click-outside';
import LogRocket from 'logrocket';
import VueSlideoutPanel from 'vue2-slideout-panel';
import InstantSearch from 'vue-instantsearch';
import {VueFormBuilderPlugin} from "./pages/Forms/index";
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import { OverlayPlugin } from 'bootstrap-vue'
import { reportFrontendError } from './utils/errorReporting';
import { installAuthTokenInterceptor } from './plugins/authTokenInterceptor';
import { installPhiMaskInterceptor, setNotifier } from './plugins/phiMaskInterceptor';
import { installStaleAuthInterceptor } from './plugins/staleAuthInterceptor';

import SwitchControl from "./pages/Forms/custom-controls/switch/SwitchControl.vue";
import SwtichConfigView from "./pages/Forms/custom-controls/switch/SwitchConfigView.vue"; 
import SignatureControl from "./pages/Forms/custom-controls/signature/SignatureControl.vue";
import SignatureConfigView from "./pages/Forms/custom-controls/signature/SignatureConfigView.vue";
import OpenDentalDataControl from "./pages/Forms/custom-controls/opendentaldata/OpenDentalDataControl.vue";
import OpenDentalDataConfigView from "./pages/Forms/custom-controls/opendentaldata/OpenDentalDataConfigView.vue";
import StatePickerControl from "./pages/Forms/custom-controls/statepicker/StatePickerControl.vue";
import WikiControl from "./pages/Forms/custom-controls/wiki/WikiControl.vue";
import WikiConfigView from "./pages/Forms/custom-controls/wiki/WikiConfigView.vue";

// Import base controls for reuse in yesNo and attachment custom types
import RadioCheckboxControl from "./pages/Forms/views/controls/RadioCheckboxControl";
import FileUploaderControl from "./pages/Forms/views/controls/FileUploaderControl";

// --- MODIFIED/ADDED: Moment Timezone Setup ---
// --- REVERTED IMPORT STRATEGY: Import base moment first ---
import moment from 'moment';
import 'moment-timezone'; // Import timezone functionality separately

// Load Timezone Data
try {
  const tzData = require('moment-timezone/data/packed/latest.json');
  moment.tz.load(tzData);
} catch (error) {
  console.error('Failed to load moment timezone data:', error);
}

// Set Default Timezone (Adjust if your primary TZ is different)
moment.tz.setDefault("America/New_York");

// Make moment available in all components via this.$moment
Vue.prototype.$moment = moment;
// --- END Moment Timezone Setup ---

// Duplicate import removed; already imported above

function subjectName(subject) {
  if (!subject || typeof subject === 'string') {
      return subject;
  }
  else if (subject.WikiPageID) {
    return "Page";
  } else
    return subject;
}

let ability = new Ability([], { subjectName });


// https://github.com/Maronato/vue-toastification

const toastOptions = {  
  position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false,
  shareAppContext: true,
  filterBeforeCreate: (toast, toasts) => {
    if (toasts.filter(
      t => t.type === toast.type
    ).length !== 0) {
      // Returning false discards the toast
      return false;
    }
    // You can modify the toast if you want
    return toast;
  }
};

// https://vue-toastification.maronato.dev/
Vue.use(Toast, toastOptions);
Vue.use(OverlayPlugin)
Vue.use(abilitiesPlugin, ability);
Vue.use(Editor)
import './filters';
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueTouch);
Vue.use(ClientTable, { theme: 'bootstrap4' });
Vue.use(VueTextareaAutosize);
Vue.directive('mask', VueMaskDirective);
Vue.use(VeeValidate, { fieldsBagName: 'fieldsbag' });
Vue.use(VueFormWizard);
Vue.use(vClickOutside);
Vue.use(VueSlideoutPanel);
Vue.use(InstantSearch);


const formConfigOptions =  {
  disableControls: [], // ['input', 'number']
  globalInjection: true,
  validationErrorShowAlert: true,
  validationErrorAlertText: "Please check the error messages and solve it.",
  controls: {
    'switch': {
        name: "Switch Field",
        description: "Single Switch",

        /**
         * Control View Mapping
         */
        //fieldComponent: require('./custom-controls/switch/SwitchControl'),
        fieldComponent: SwitchControl,

        /**
         * Control Configuration View Mapping
         */
        //configComponent: require('./custom-controls/switch/SwitchConfigView'),

        configComponent: SwtichConfigView,

        /**
         * Control-Data Extend
         * Your specific data for your custom control
         */
        configData: {
            isChecked: false,
            switchColor: "#64bd63"
        },

        /**
         * Default data of the Switch in Renderer
         * @returns {boolean}
         */
        rendererDefaultData() {
            return false;
        },
    },

    'signature': {
      name: "Signature Field",
      description: "Collect Signature Online",

      /**
       * Control View Mapping
      */      
      fieldComponent: SignatureControl,

      /**
       * Control Configuration View Mapping
       */
      configComponent: SignatureConfigView,

      /**
       * Control-Data Extend
       * Your specific data for your custom control
       */
      configData: {
          minWidth: 3,
          maxWidth: 5,
          backgroundColor:'rgb(250,250,250)'
      },

      /**
       * Default data of the Switch in Renderer
       * @returns {boolean}
       */
      rendererDefaultData() {
          return "";
      },
    },

    'opendentaldata': {
      name: 'Open Dental Data Field',
      description: "Add Allergies, Medications, Diseases / Problem, and Referrals with Options from your Open Dental",
      fieldComponent: OpenDentalDataControl,
      configComponent: OpenDentalDataConfigView,
      configData: {
        dataType: '',
        selectedOptions: []
      }
    },

    'statepicker': {
      name: 'US State Picker',
      description: "Select from all US States",
      fieldComponent: StatePickerControl,
    },

    'wiki': {
      name: 'Wiki',
      description: "WYSIWYG Editor",
      fieldComponent: WikiControl,
      configComponent: WikiConfigView
    },

    // Legacy control types - reusing existing controls
    'yesNo': {
      name: 'Yes/No',
      description: "Simple Yes/No selection (legacy)",
      fieldComponent: RadioCheckboxControl,
      configData: {
        displayMode: 'line',
        position: 'left',
        items: [
          { text: 'Yes', value: 'yes' },
          { text: 'No', value: 'no' }
        ]
      }
    },

    'attachment': {
      name: 'Attachment',
      description: "File attachment upload (legacy)",
      fieldComponent: FileUploaderControl,
      // Uploads store [{name,url},...]: required = at least one file, min/max = file count.
      // isEmail/regex/sameAs/customClosure cannot pass on a file list, so the builder only
      // offers these three (read by SidebarControlConfiguration.allowedValidationRules).
      allowedValidationRules: ['required', 'min', 'max'],
      validationRuleDescriptions: {
        required: 'Patient must upload at least one file',
        min: 'Minimum number of files',
        max: 'Maximum number of files',
      },
      configData: {
        buttonLabel: "Select File",
        buttonClasses: "btn btn-primary",
        extensions: ".gif,.png,.jpg,.jpeg,.pdf,.doc,.docx",
        accept: "image/*,application/pdf,.doc,.docx",
        maxSize: 10000000,
        isMultiple: false,
        maximumFiles: 1,
        // '' = use the form's uploads category (formConfig.attachmentCategory); a DefNum overrides it for this field only
        attachmentCategory: ''
      },
      rendererDefaultData() {
        return [];
      }
    }
  }
};

Vue.use(VueFormBuilderPlugin, formConfigOptions);

// Login token on our own API calls (request-auth phase 0). Installed BEFORE the PHI mask on purpose:
// axios runs request interceptors in reverse order, so the demo-mask send block still runs first.
// See src/utils/authHeaderPolicy.js for which requests get it.
installAuthTokenInterceptor();

// PHI mask — must be installed BEFORE any component mounts and fires a request,
// otherwise the first page-load payload arrives unmasked. See
// src/plugins/phiMaskInterceptor.js for why one interceptor covers the whole app.
installPhiMaskInterceptor();
setNotifier((msg) => {
  try { Vue.$toast.warning(msg); } catch (e) { console.warn('[phiMask]', msg); }
});

// Self-healing 401: a 401 on an endpoint we're authenticated for means either a STALE bundle
// (reload into the new one, which sends the token) or a lapsed Firebase token (silent refresh).
// Gated on proven version drift so it never reload-loops. See plugins/staleAuthRecovery.js.
installStaleAuthInterceptor();

Vue.config.productionTip = false;

if(process.env.NODE_ENV.toUpperCase() === 'PRODUCTION') {
  Vue.config.devtools=false;
  Vue.config.debug = false;
}

// Install global error handlers
window.onerror = function(message, source, lineno, colno, error) {
    try {
      reportFrontendError(error || { message, source, lineno, colno });
    } catch (e) {
      // Avoid breaking the app if reporter fails
      console.error('Error in global onerror reporter:', e);
    }
};

window.onunhandledrejection = function(event) {
    try {
      reportFrontendError(event.reason || { message: 'Unhandled promise rejection', event });
    } catch (e) {
      console.error('Error in unhandledrejection reporter:', e);
    }
};

Vue.config.errorHandler = function(err, vm, info) {
    try {
      reportFrontendError(err, { info });
    } catch (e) {
      console.error('Error in Vue errorHandler reporter:', e);
    }
};

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
});

// Expose Vue instance for error reporting utility
window.__teamioVue__ = app;
